import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryGetCriticalityWeightScurveGraph } from 'api/queries/getCriticalityWeightScurveGraph.query';

import { FilterNames, getFiltersData } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

import { getDecodedValue } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/programProgressOverview.utils';
import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

export const useScurveProvider = ({
    componentKey,
    widgetId,
    contractId,
    projectId,
    latestVersionId,
    compareVersionId,
    globalFilterData,
    localFilters,
}) => {
    const { isGenerativeAi } = usePinboardWidgetWrapperContext();
    const source = widgetId ? localFilters : globalFilterData;
    const isInPinboard = Boolean(widgetId);

    const state = {
        project: {
            projectId,
            contractId,
            latestVersionId,
            compareVersionId,
        },
        globalFilter: {
            progressMeasurement: source?.progressMeasurement,
            resource: source?.resource,
            resourceType: source?.resourceType,
            activityCodes: source?.activityCodes,
            milestoneFragnet: source?.milestoneFragnet,
            tags: source?.tags,
            wbs: source?.wbs,
        },
    };

    const pillsData = {
        progressMeasurement: source?.progressMeasurement,
        resource: source?.resource,
        resourceType: source?.resourceType,
        activityCodes: source?.activityCodes?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        activityCodesExclude: source?.activityCodes?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        milestoneFragnet: source?.milestoneFragnet,
        tags: source?.tags?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        tagsExclude: source?.tags?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        wbs: source?.wbs,
    };

    // create pill data for PinboardWidgetPills component
    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId });

    // Queries
    const payload = {
        actualMetaDataId: latestVersionId,
        baselineMetaDataId: compareVersionId || latestVersionId,
        graphType: getDecodedValue(source?.progressMeasurement)?.progressMeasurement,
        isPartialCompletion: getDecodedValue(source?.progressMeasurement)?.partialCompletionCredit,
        filter: {
            filters: getFiltersData({
                [FilterNames.ACTIVITY_CODES]: source?.activityCodes
                    ?.filter((item) => !item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.ACTIVITY_CODES_EXCLUDE]: source?.activityCodes
                    ?.filter((item) => item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.FRAGNET_SEARCH]: source?.milestoneFragnet,
                [FilterNames.TAG_CARD_BOARD]: source?.tags
                    ?.filter((item) => !item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.TAG_CARD_BOARD_EXCLUDE]: source?.tags
                    ?.filter((item) => item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.WBS_SEARCH]: source?.wbs,
                [FilterNames.RESOURCE_NAME_CARD_BOARD]: source?.resource,
                [FilterNames.RESOURCE_TYPE_CARD_BOARD]: source?.resourceType,
            }),
        },
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId),
    };

    return {
        ui: {
            state: {
                ...state.project,
                ...state.globalFilter,
            },
            isInPinboard,
            pills,
        },
        api: {
            scurveGraph: {
                instance: useQueryGetCriticalityWeightScurveGraph(payload),
                payload: payload,
            },
        },
    };
};
